import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';
import ThumbsDown from '../../../assets/images/ThumbsDown.svg';
import Fireworks from '../../../assets/images/Fireworks.svg';
import { CompetitionStyleVariant } from './Competition.types';

export const Wrapper = styled.div<{ $style: CompetitionStyleVariant }>`
  width: 100%;
  margin-top: ${spacing.space24};
  margin-bottom: ${spacing.space24};
`;

export const Container = styled.div<{ $style: CompetitionStyleVariant }>`
  max-width: 564px;
  padding: ${spacing.space24};
  border-radius: ${spacing.space20};
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.24);

  ${({ $style }) =>
    $style === 'spruce'
      ? css`
          color: ${nafColor.signature.white};
          background-color: ${colors.secondary[900]};
        `
      : css`
          color: ${nafColor.signature.black};
          background-color: ${nafColor.signature.white};
        `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
  }

  h3 {
    margin: 0;
    margin-top: ${spacing.space12};
  }
`;

export const FireworksImage = styled(Fireworks)`
  margin-top: ${spacing.space16};
`;

export const ThumbsDownImage = styled(ThumbsDown)`
  margin-top: ${spacing.space16};
`;
